module.exports = __webpack_public_path__ + "img/close-groups-modal.a704e0cd.svg";